import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemActivitiesByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemActivitiesByIdController.php
* @route '/api/item/{item}/activities'
*/
const GetItemActivitiesByIdController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemActivitiesByIdController.url(args, options),
    method: 'get',
})

GetItemActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/item/{item}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemActivitiesByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemActivitiesByIdController.php
* @route '/api/item/{item}/activities'
*/
GetItemActivitiesByIdController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetItemActivitiesByIdController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemActivitiesByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemActivitiesByIdController.php
* @route '/api/item/{item}/activities'
*/
GetItemActivitiesByIdController.get = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemActivitiesByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemActivitiesByIdController.php
* @route '/api/item/{item}/activities'
*/
GetItemActivitiesByIdController.head = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetItemActivitiesByIdController